var _path, _path2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconInternational64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_18941)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 56.5029C45.2548 56.5029 56 45.7578 56 32.5029C56 19.2481 45.2548 8.50293 32 8.50293C18.7452 8.50293 8 19.2481 8 32.5029C8 45.7578 18.7452 56.5029 32 56.5029Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1916_18941",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 48,
    height: 49
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 56.5029C45.2548 56.5029 56 45.7578 56 32.5029C56 19.2481 45.2548 8.50293 32 8.50293C18.7452 8.50293 8 19.2481 8 32.5029C8 45.7578 18.7452 56.5029 32 56.5029Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1916_18941)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 56.5029C45.2548 56.5029 56 45.7578 56 32.5029C56 19.2481 45.2548 8.50293 32 8.50293C18.7452 8.50293 8 19.2481 8 32.5029C8 45.7578 18.7452 56.5029 32 56.5029Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1967 7.27197C33.8672 9.18476 32.1731 11.5914 32.1145 14.4918C32.0267 18.8425 37.7154 16.5046 37.7154 19.6463C37.7154 22.788 34.0069 23.3677 30.6702 20.174C27.3335 16.9803 23.6366 16.6194 20.3226 19.4744C17.0085 22.3294 16.4641 29.8406 22.1721 31.0034C27.8801 32.1662 28.7122 32.6193 28.7122 38.3973C28.7122 44.1752 29.4637 45.4258 33.9382 45.4258C38.4127 45.4258 36.0209 40.7524 37.7154 37.7252C39.4099 34.698 42.3385 33.1181 42.3385 30.657C42.3385 28.1958 36.6543 28.6213 37.7154 25.1857C38.7766 21.75 43.8123 23.6123 46.2538 22.177C48.6953 20.7418 50.3652 15.1016 49.6987 14.4918C49.3911 14.2105 48.2902 12.616 44.9142 10.5568C43.6987 9.81546 42.7646 8.86498 41.2846 8.39162C40.15 7.93451 38.7873 7.5613 37.1967 7.27197Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 56.5029C45.2548 56.5029 56 45.7578 56 32.5029C56 19.2481 45.2548 8.50293 32 8.50293C18.7452 8.50293 8 19.2481 8 32.5029C8 45.7578 18.7452 56.5029 32 56.5029Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_18941"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0 0.50293)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconInternational64);
export default __webpack_public_path__ + "static/media/pictogramBeaconInternational64.9c256bb6dcac4d262e47c46152b032e8.svg";
export { ForwardRef as ReactComponent };